// removed by extract-text-webpack-plugin
module.exports = {"ad":"style-ad-1a6a015f","banner":"style-banner-cfb9c0c5","mpu":"style-mpu-fdfb992c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Ads/style.scss
// module id = 360
// module chunks = 0